import Vue from 'vue'
import Vuex from 'vuex'
import jwt_decode from 'jwt-decode'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        accessToken: localStorage.getItem('access_token') || null,
        refreshToken: localStorage.getItem('refresh_token') || null,
        APIData: localStorage.getItem('APIData') || null,
        tokenExpired: localStorage.getItem('tokenExpired') || null,
        isAdmin: localStorage.getItem('isAdmin') || false
    },
    getters: {
        loggedIn(state) {
            return state.accessToken != null
        },
        payload(state) {
            return state.APIData
        },
        username(state) {
            const data = JSON.parse(state.APIData)
            return (data.username).replace(/\s/g, '')
        },
        userId(state) {
            const data = JSON.parse(state.APIData)
            return data.id
        },
        isAdmin(state) {
            return state.isAdmin
        },
        timeExpiredToken(state) {
            return state.tokenExpired
        }
    },
    mutations: {
        updateLocalStorage(state, { access, refresh }) {
            const token_jwt = jwt_decode(access);
            const arrayUser = JSON.stringify(token_jwt)

            localStorage.setItem('access_token', access)
            localStorage.setItem('refresh_token', refresh)
            localStorage.setItem('APIData', arrayUser)
            localStorage.setItem('tokenExpired', token_jwt.exp)
            state.APIData = arrayUser
            state.accessToken = access
            state.refreshToken = refresh
            state.tokenExpired = token_jwt.exp
            var BreakException = {};
            try {
                (token_jwt.role).forEach(function (i) {
                    const role = (i).replace(/\s/g, '');
                    if (role == "Admin") {
                        state.isAdmin = true
                        localStorage.setItem('isAdmin', true)
                        throw BreakException;
                    }
                });
            } catch (e) {
                if (e !== BreakException) throw e;
            }
        },
        updateAccess(state, access) {
            const token_jwt = jwt_decode(access);
            localStorage.setItem('access_token', access)
            localStorage.setItem('refresh_token', access)
            localStorage.setItem('tokenExpired', token_jwt.exp)
            state.accessToken = access
            state.refreshToken = access
            state.tokenExpired = token_jwt.exp
        },
        destroyToken(state) {
            localStorage.clear()
            state.accessToken = null
            state.refreshToken = null
            state.APIData = null
            state.tokenExpired = null
        }
    },
    actions: {
        logoutUser(context) {
            if (context.getters.loggedIn) {
                context.commit('destroyToken')
                //this.$router.push("/login")
            }
        },
        loginUser(context, credentials) {
            context.commit('updateLocalStorage', { access: credentials.access, refresh: credentials.refresh })
        },
        updateToken(context, credentials) {
            context.commit('updateAccess', credentials)
        },

        authenticate: ({ commit }, access, refresh) => commit('updateLocalStorage', { access, refresh })
    }
})


// WEBPACK FOOTER //
// ./src/store.js